<template>
    <div class="block-editor google-drive-download-file">
        <section>
            <div class="title">{{ $t('auto.googleDriveDownloadFileChannelId') }}</div>
            <TiptapEditor placeholder="Google Drive Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.googleDriveDownloadFileDosyanNIndirileceIGoogleDriveKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googleDriveDownloadFileFileId') }}</div>
            <TiptapEditor placeholder="Google Drive File ID" :show-attributes="true" v-model="clone.fileId" automation-mode />
            <small>{{ $t('auto.googleDriveDownloadFileNdirilecekDosyanNGoogleDriveIdsi') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GoogleDriveDownloadFile",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                fileId: "",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-drive-download-file {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
